import React, { Component } from 'react';
import { Button, Label, Input } from 'reactstrap';

const initialState = {
    first_name: '',
    last_name: '',
    email: '',
    user_type: '',
    firstNameError: '',
    lastNameError: '',
    emailError: '',
    userTypeError: '',
    successMsg: '',
};

class AddTeamUser extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    // Handle success and reset (same logic as original)
    UNSAFE_componentWillReceiveProps(nextProps) {
        // ✅ On successful invite
        if (nextProps.data?.teamUser?.success === true) {
            this.setState({ successMsg: 'User invitation sent successfully!' });

            // Reset form and close modal after delay
            setTimeout(() => {
                this.setState(initialState);
                if (this.props.onClose) this.props.onClose();
            }, 1000);
        }

        // ✅ Handle external reset trigger
        if (nextProps.resetData === true) {
            this.setState(initialState, () => {
                if (nextProps.resetDataChangeHandler)
                    nextProps.resetDataChangeHandler();
            });
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    // ✅ Validation (same as old)
    validate() {
        let firstNameError = '';
        let lastNameError = '';
        let emailError = '';
        let userTypeError = '';

        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if (!this.state.first_name) firstNameError = 'First name is required';
        if (!this.state.last_name) lastNameError = 'Last name is required';
        if (!this.state.email) emailError = 'Email is required';
        else if (!mailformat.test(this.state.email))
            emailError = 'You have entered an invalid email';
        if (!this.state.user_type) userTypeError = 'Access type is required';

        if (firstNameError || lastNameError || emailError || userTypeError) {
            this.setState({ firstNameError, lastNameError, emailError, userTypeError });
            return false;
        }
        return true;
    }

    // ✅ Map payload to Laravel expected fields
    handleSaveClick = () => {
        if (this.validate()) {
            const { first_name, last_name, email, user_type } = this.state;

            const payload = {
                first_name,
                last_name,
                email,
                user_type,
            };

            this.props.onClickhandleSaveClick(payload);
        }
    };

    render() {
        const { accessType = [] } = this.props.data || {};

        return (
            <div className="card-body">
                {/* Info Header */}
                <div className="alert alert-info mb-3">
                    Complete the user info below and an invitation will be sent to the user.
                </div>
                <p className="card-text">
                    Add more users to your enterprise account to collaborate.
                </p>

                {/* Success Message */}
                {this.state.successMsg && (
                    <div id="successMsg" style={{ color: 'green', textAlign: 'center' }}>
                        {this.state.successMsg}
                    </div>
                )}

                <div className="user-form-section col-sm-12 col-md-12 col-lg-12 p-0">
                    {/* 🧩 First Name / Last Name */}
                    <div className="form-group row">
                        <div className="col-sm-6">
                            <Label>
                                First Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="first_name"
                                name="first_name"
                                value={this.state.first_name}
                                onChange={this.handleChange}
                            />
                            <div style={{ color: 'red' }}>{this.state.firstNameError}</div>
                        </div>

                        <div className="col-sm-6">
                            <Label>
                                Last Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="last_name"
                                name="last_name"
                                value={this.state.last_name}
                                onChange={this.handleChange}
                            />
                            <div style={{ color: 'red' }}>{this.state.lastNameError}</div>
                        </div>
                    </div>

                    {/* 🧩 Email + Access Type */}
                    <div className="form-group row">
                        <div className="col-sm-6">
                            <Label>
                                Email <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control"
                                id="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                            <div style={{ color: 'red' }}>{this.state.emailError}</div>
                        </div>

                        <div className="col-sm-6">
                            <Label>
                                Access Type <span className="text-danger">*</span>
                            </Label>
                            <Input
                                type="select"
                                className="form-control"
                                id="user_type"
                                name="user_type"
                                value={this.state.user_type}
                                onChange={this.handleChange}
                            >
                                <option value="">--Select access type--</option>
                                {accessType?.length > 0 &&
                                    accessType.map((type, index) => (
                                        <option key={index} value={type.UserTypeID}>
                                            {type.UserTypeName}
                                        </option>
                                    ))}
                            </Input>
                            <div style={{ color: 'red' }}>{this.state.userTypeError}</div>
                        </div>
                    </div>

                    {/* 🧩 Buttons */}
                    <div className="form-group row mt-4">
                        <div className="col-12 text-center">
                            <Button
                                color="primary"
                                style={{
                                    backgroundColor: '#083ac8',
                                    border: 'none',
                                    width: '200px',
                                    borderRadius: '5px',
                                    marginRight: '1.5rem',
                                }}
                                onClick={this.handleSaveClick}
                            >
                                Send Invitation
                            </Button>

                            <Button
                                color="secondary"
                                style={{
                                    backgroundColor: '#6c757d',
                                    border: 'none',
                                    width: '150px',
                                    borderRadius: '5px',
                                }}
                                onClick={() => this.props.onClose && this.props.onClose()}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddTeamUser;
